import { render, staticRenderFns } from "./Gestion.vue?vue&type=template&id=5c4ca087&scoped=true&"
import script from "./Gestion.vue?vue&type=script&lang=js&"
export * from "./Gestion.vue?vue&type=script&lang=js&"
import style0 from "./Gestion.vue?vue&type=style&index=0&id=5c4ca087&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ca087",
  null
  
)

export default component.exports